"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectErrorViewContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _view = require("../../actions/view");
var _AccountSelectErrorView = require("./AccountSelectErrorView");
var _ = require("../../..");
var _reactRedux = require("react-redux");
var _phoneAuth = require("../../actions/phoneAuth");
var _source = require("../../selectors/source");
function mapStateToProps(state) {
  return {
    email: state.phoneAuth.authenticateByToken.account,
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    retry(email) {
      if (email) {
        dispatch((0, _phoneAuth.authenticateByToken)({
          email
        }));
      } else {
        dispatch((0, _phoneAuth.registerOrAuthorizeByToken)());
      }
      dispatch((0, _view.changeView)(_.EActiveView.AccountSelect));
    },
    backToList() {
      dispatch((0, _view.changeView)(_.EActiveView.AccountSelect));
    }
  };
}
const AccountSelectErrorViewContainer = exports.AccountSelectErrorViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_AccountSelectErrorView.AccountSelectErrorView);